export enum ProfileStatusProperties {
  ProfileStatusType = 'profileStatusType',
  IssueHistory = 'issueHistory',
  Owner = 'owner',
  Id = 'id',
  Created = 'created',
  Updated = 'updated',
  Deleted = 'deleted',
  Version = 'version',
  AutomaticBrandPublishing = 'automaticBrandPublishing',
}
export enum ProfileStatusMetaProperties {
  IssueHistoryId = 'IssueHistory-id',
  IssueHistoryVersion = 'IssueHistory-version',
}
